import { app } from '../../../../../app';
import { Controller } from './delete-user.controller';

app.component('companyUserDirectoriesManageUserDeleteUser', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./delete-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/delete-user/delete-user.component.js